import { PageContent, PageSection } from '@root/Design/Layout';
import { endpoint } from '@root/Services/Router/EndpointRegistry';
import { ActionLogGrid } from '@root/Components/Actions/ActionsGrid';
import { Tabs } from '@mantine/core';
import { useEffect, useState } from 'react';
import { ResourceChangeGrid } from '@root/Components/Actions/ResourceChangeGrid';
import { useNavState } from '@root/Services/Router/NavState';
import { useNav } from '@root/Services/NavigationService';
import { HistoricalNotificationsGrid } from '@root/Components/Notifications/HistoricalNotificationsGrid';
import { useResizeNeeded } from '@root/Design/Primitives';
import { useDiMemo } from '@root/Services/DI';
import { NotificationViewerService } from '@root/Services/Notification/NotificationViewerService';
export function ActionsLog() {
    return (
        <PageContent>
            <ActionsLogContent />
        </PageContent>
    );
}
export function ActionsLogContent() {
    const { section, setSection } = useNavState({ section: 'Activity' });
    const resizeNeeded = useResizeNeeded();
    function tabPropertyChange(e: any) {
        setSection(e);
        resizeNeeded();
    }

    return (
        <PageSection height="full" style={{ padding: 0 }}>
            <Tabs value={section} onTabChange={tabPropertyChange} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Tabs.List px="md" pt="xs">
                    <Tabs.Tab data-atid="ActionsLogTab" value="Activity">
                        Actions Log
                    </Tabs.Tab>
                    <Tabs.Tab data-atid="ResourceChangeLogTab" value="ResourcChangeLog">
                        Resource Change Log
                    </Tabs.Tab>
                    <Tabs.Tab data-atid="ResourceChangeLogTab" value="Notifications">
                        Notifications
                    </Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel sx={{ height: '100%', minHeight: 0 }} p="md" value="Activity">
                    {section === 'Activity' ? <ActionLogGrid></ActionLogGrid> : null}
                </Tabs.Panel>
                <Tabs.Panel sx={{ height: '100%', minHeight: 0 }} value="ResourcChangeLog">
                    {section === 'ResourcChangeLog' ? <ResourceChangeGrid></ResourceChangeGrid> : null}
                </Tabs.Panel>
                <Tabs.Panel sx={{ height: '100%', minHeight: 0 }} p="md" value="Notifications">
                    {section === 'Notifications' ? <NotificationsTab /> : null}
                </Tabs.Panel>
            </Tabs>
        </PageSection>
    );
}

export function NotificationsTab() {
    const { getData, removeData } = useNav();
    const viewerSvc = useDiMemo(NotificationViewerService);
    useEffect(() => {
        const { notificationId: rawNotifId } = getData('notificationId');
        const notifId = rawNotifId ? parseInt(rawNotifId) : undefined;
        if (notifId) {
            viewerSvc.view(notifId);
            removeData('notificationId');
        }
    }, []);
    return <HistoricalNotificationsGrid />;
}
function MyNotificationsEndpoint() {
    const { move, getData } = useNav();

    useEffect(() => {
        const { notificationId } = getData('notificationId');
        move('actionslog', { section: 'Notifications', ...(notificationId ? { notificationId } : {}) });
    }, []);
    return <></>;
}
endpoint('actionsLog', ActionsLog, 'Activity Log');
endpoint('my-notifications', MyNotificationsEndpoint, 'Activity Log');
